import { debounce, clone } from "underscore";
import queryString from "query-string";

import type { IMEGSFilteringParameters } from "../types/MEGS.types";
import type { DataRequested } from "../types/app.types";

type UpdateAddressBarParams = {
  reqUpdateAddressBar: { current: boolean };
  setUserLink: (link: string) => void;
  sliderValues: Array<number> | undefined;
  dataRequested: DataRequested;
  version: string;
  contentToDisplay: string;
  pageMode: boolean;
  MEGSFilteringParameters: Array<IMEGSFilteringParameters>;
};

type QueryValues = {
  page: string;
  version: string;
  country: string;
  year: string | number;
  sliderValues?: Array<number>;
  [techName: string]: string | number | Array<number> | undefined;
};

export const updateAddressBar = debounce(
  ({
    reqUpdateAddressBar,
    setUserLink,
    sliderValues,
    dataRequested,
    version,
    contentToDisplay,
    pageMode,
    MEGSFilteringParameters,
  }: UpdateAddressBarParams) => {
    if (sliderValues !== undefined && reqUpdateAddressBar.current) {
      const userValues = clone(sliderValues);
      userValues.splice(8, 1);
      let page;
      if (!pageMode) {
        page = "charts";
      } else {
        page = contentToDisplay;
      }
      if (contentToDisplay !== "home") {
        let newQuery = `?`;

        const queryValues: QueryValues = {
          page,
          version,
          country: dataRequested.country,
          year: dataRequested.year,
        };
        if (dataRequested.dataset === "megs") {
          MEGSFilteringParameters.forEach(
            (item) => (queryValues[item.techName] = item.values),
          );
        }
        if (dataRequested.dataset === "esx")
          queryValues.sliderValues = userValues;

        newQuery =
          newQuery +
          // query-string stringify accepts a loosely-typed record.
          queryString.stringify(queryValues, {
            arrayFormat: "comma",
          });

        setUserLink(`https://modelling.energy/${newQuery}`);
        window.history.pushState({ page: 1 }, "userValues", newQuery);
      }
    }
    reqUpdateAddressBar.current = true;
  },
  500,
);
